import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

import { MDBDataTable } from "mdbreact"

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
 
  

} from "reactstrap"
import Select from "react-select"
import axios from 'axios'
import  { Redirect } from 'react-router-dom'
// import $ from "jquery";

import Flatpickr from "react-flatpickr"
import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"
import url from "../../common/api"

class ListeEvenement extends Component {


  constructor(props) {
    super(props)
    this.state = {
      ok:"",
      evenementData:[],
      evenement:[],
       
    }
    this.handleDetail.bind(this)
  }
  componentDidMount() {

    this.handleChargerData()

     

  }

  handleDetail=(id)=>{
    sessionStorage.setItem('idressource',id);
    this.setState({ok: <Redirect to='/detail-evenement'  />});
  }


  handleChargerData=()=>{
    var data=JSON.parse(sessionStorage.getItem("authAshia")).profile
    sessionStorage.setItem("profileAuthAshia", JSON.stringify(data))
    
   fetch(url+"profiles/"+data.id)
      .then((response) => response.json())
      .then((data) => {
        this.setState({evenementData:data.evenements})
        
        data.evenements.map((element,idx) =>{
          var tab= {
            libelle: element.libelle,
            //thematique: element.nom,
            date: element.date_debut,
            //format: element.format.code,
            //langue: element.nom,
            lieu: element.lieu,
            //typesystemeirrigue: element.nom,
         
            action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} className="bx bxs-info-circle bx-sm text-primary "/> </a>,
            
          }
         
          this.setState({evenement:[...this.state.evenement,tab]})
        })
      
        
        
       }
       
      );
  }

  handleAjoutEvenement=()=>{
    this.setState({ok: <Redirect to='/ajout-evenement'  />});
  }

  render() {

    const data = {
      columns: [
        {
          label: "Libelle",
          field: "libelle",
          sort: "asc",
          width: 150,
        },
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 270,
        },
        {
          label: "Lieu",
          field: "lieu",
          sort: "asc",
          width: 100,
        },
        {
          label: "Action",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
      rows:this.state.evenement
      
    }


    return (
      <React.Fragment>
        <div className="page-content"> 
          
          <MetaTags>
              <title>Evenements</title>
          </MetaTags>

          <Container fluid={true}>
            <Row>
              <Col md="8">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18">Evenements</h4>
                </div>
              </Col>
            </Row>

            <hr/>

            <Row>
              <Col md="6" className="pull-right">
                <Button
                  color="info"
                  className="font-16 btn-block btn btn-primary  float-right"
                  onClick={this.handleAjoutEvenement}
                  href="/ajout-evenement"
                >
                  <i className="mdi mdi-plus-circle-outline me-1" />
                  Ajouter un événement
                </Button>
              </Col>
            </Row>

            <hr/>
            <Row>

            <MDBDataTable responsive sortable={false} striped bordered  style={{textAlign:"justify"}}  data={data} />

            </Row>
              
            
          </Container>
        </div>
        
      </React.Fragment>
    )
  }
}
export default ListeEvenement